import Autosuggest from "react-autosuggest";

const NewFormColumn = (props) => {
  const containerStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px 20px",
    alignItems: "center",
  };

  const fieldWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  };

  const labelStyle = {
    marginBottom: "4px",
    fontWeight: 600,
    fontSize: "15px",
  };

  const inputBaseStyle = {
    width: "200%",
    height: "32px",
    padding: "6px 10px",
    border: "1px solid #aaa",
    borderRadius: "4px",
    fontSize: "14px",
    boxSizing: "border-box",
  };

  const dropdownBaseStyle = {
    width: "48%",
    height: "32px",
    padding: "6px 10px",
    border: "1px solid #aaa",
    borderRadius: "4px",
    fontSize: "14px",
    boxSizing: "border-box",
  }

  return (
    <div style={containerStyle}>
      {props.groupInfo[props.groupName].map((info) => {
        // Hide billing party if not To Be Billed
        if (info.name === "billing_party_name" && String(props.myFormObj.pageState.pay_type) !== "4") {
          return null;
        }

        // Full width for specific fields
        const isFullWidth = ["pay_type", "billing_party_name"].includes(info.name);
        const finalWrapperStyle = isFullWidth
          ? { ...fieldWrapperStyle, gridColumn: "1 / span 2" }
          : fieldWrapperStyle;

        return (
          <div key={info.name} style={finalWrapperStyle}>
            {props.checkVisibilityCondition(info) && (
              <label style={labelStyle}>{info.label}</label>
            )}

            {info.type === "dropdown" ? (
              <select
                style={dropdownBaseStyle}
                onChange={(e) => props.myFormObj.handleChangeForSelect(e, info.name)}
                disabled={props.checkDisabledCondition(info)}
                value={props.myFormObj.pageState[info.name]}
                ref={(a) => props.myFormObj.storeInputReferenceForSelect(a, info.name)}
                onKeyPress={(a) => props.myFormObj.onKeyPressForKeyNav(a, info)}
              >
                {info.dropdown_items.map((item) => (
                  <option value={item.value} key={item.label}>
                    {item.label}
                  </option>
                ))}
              </select>
            ) : info.type === "date" ? (
              <input
                type="date"
                style={inputBaseStyle}
                name={info.name}
                onChange={(e) => props.myFormObj.handleChange(e)}
                disabled={props.checkDisabledCondition(info)}
                value={props.myFormObj.pageState[info.name]}
                ref={(a) => props.myFormObj.storeInputReferenceForSelect(a, info.name)}
                onKeyPress={(a) =>
                  props.myFormObj.onKeyPressForKeyNav(a, info, props.myFormObj.pageState)
                }
              />
            ) : (
              <Autosuggest
                id={info.name}
                suggestions={props.myFormObj.suggestions || []}
                onSuggestionsFetchRequested={(a) => {
                  if (info.apiConfigKey) {
                    props.myFormObj.onSuggestionsFetchRequestedDebounced(
                      a,
                      (b) =>
                        props.myFormObj.suggestionFetchApi(
                          info,
                          b,
                          props.getAdditionalInfoForSuggestionFetch(info)
                        )
                    );
                  }
                }}
                onSuggestionsClearRequested={() =>
                  props.myFormObj.onSuggestionsClearRequested(info)
                }
                getSuggestionValue={(suggestion) => suggestion[info.suggestionKeyword]}
                onSuggestionSelected={(a, b) =>
                  props.myFormObj.getSuggestionValue(
                    b.suggestion,
                    info,
                    props.myFormObj.performSuggestions,
                    props.myFormObj.updatePageStateForGetSuggestion
                  )
                }
                renderSuggestion={(a) => props.myFormObj.renderSuggestion(a, info)}
                highlightFirstSuggestion={true}
                ref={(a) => props.myFormObj.storeInputReference(a, false)}
                inputProps={{
                  placeholder: info.placeholder,
                  value: String(props.myFormObj.pageState[info.name] || ""),
                  onChange: (a, b) => props.myFormObj.onChangeAutoSuggest(a, b, info),
                  onBlur: () => props.myFormObj.onblurValidator(info),
                  onKeyPress: (a) =>
                    props.myFormObj.onKeyPressForKeyNav(a, info, props.myFormObj.pageState),
                  disabled: props.checkDisabledCondition(info),
                  style: inputBaseStyle,
                }}
              />
            )}

            {props.myFormObj.internalValidationErrors[info.name] && (
              <p style={{ color: "red", margin: "4px 0 0", fontSize: "12px" }}>
                {props.myFormObj.internalValidationErrors[info.name]}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NewFormColumn;

